import { RadioPillsField } from '@app/components/various/Form';
import { Logo, LogoType } from '@app/components/various/Logo';
import { getOrderDetails, getPaymentTerm, setActiveOrderPaymentMethod } from '@app/ducks';
import { usePaymentMethodsByMode } from '@app/logic/hooks/usePaymentMethodsByName';
import { isDefined } from '@app/utils/is';
import { isEmpty } from '@app/utils/isEmpty';
import { Payments, Radio } from '@typings';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

const PAYMENT_METHOD_ICON: Record<Payments.PaymentMethodType, Maybe<LogoType>> = {
  pay_later: null,
  paypal_wholesale: LogoType.PayPal,
  stripe_checkout: LogoType.Stripe,
  stripe_checkout_wholesale: LogoType.Stripe,
};

export const CheckoutPaymentMethods = () => {
  const dispatch = useDispatch();
  const paymentTerm = useSelector(getPaymentTerm);

  const orderDetails = useSelector(getOrderDetails);
  const paymentMethods = usePaymentMethodsByMode(paymentTerm, orderDetails.order.paymentMethods ?? []);

  const options: Radio.PillOption[] = React.useMemo(
    () =>
      paymentMethods.map(method => {
        const methodLogo = PAYMENT_METHOD_ICON[method.paymentMethodType];

        return {
          description: method.description,
          name: method.name,
          postfix: isDefined(methodLogo) && <Logo size={38} type={methodLogo} />,
          value: method.paymentMethod,
        };
      }),
    [paymentMethods],
  );

  if (isEmpty(paymentMethods)) {
    return null;
  }

  const handleChange = (value: string) => {
    dispatch(setActiveOrderPaymentMethod(value));
  };

  return <RadioPillsField name="paymentMethod" options={options} onChange={handleChange} />;
};
